import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CONFIGURATION } from '../app.constants';
import { DealerSourceMapping, NonCDKDealer, ReturnMailer, Subscriber, ClientSubscription, Dealer } from '../models';
import { throwError } from 'rxjs';
import 'rxjs/add/operator/catch';
import * as _ from 'underscore';


declare var config: any;
@Injectable({ providedIn: 'root' })
export class FileuploadService {
    constructor(private http: HttpClient) { }
    private AdmtServiceUrl = CONFIGURATION.baseUrls.ADMTServiceURL;
    
    getListAMGBucketKeys(): Observable<any> {
        const url = this.AdmtServiceUrl + 'file-upload/getListAMGBucketKeys';
        return this.http.get(url);
    }
    uploadDealerFile(listpath, ListName,createdBy): Observable<any> {
        const url = this.AdmtServiceUrl + 'file-upload/uploaddealerfile?listname='+ListName+'&listpath='+listpath+'&createdby='+createdBy;
        return this.http.get(url);
    }  
    ///------------Response JSON------------------
    private extractData(response: Response) {

        let body = response.json();
        return body;
    }
    handleServerError(error: any | any) {
        console.log(error.error || error.json() || error);
        return throwError(error.error || error.json() || error || 'Server error');
    }
}